@if (!(loadingPriceList$|async) && !(loadingTpl$|async)) {
  @if (price && price.value !== -1 && (templates$|async)?.[previewTemplateVar]) {
    <div class="preview-tamplate" [innerHtml]="(templates$|async)[previewTemplateVar] | replaceTokensArray: {keys: price, previewVar: previewTemplateVar} | safe: 'html'"></div>
  } @else {
    <div class="d-flex">
      @if (!priceDisplay) {
        <div>
          @if (price && price.value !== -1) {
            <div class="current-price" [ngClass]="{'sale-price': price.striped !== -1}">
              {{(showAutoShipment && price.autoShipmentPrice !== -1 ? price.autoShipmentPrice : price?.value)|currency:price?.currency:currencySymbol}}
              @if (price && price.striped !== -1) {
                <div class="striped">
                  {{price?.striped|currency:price?.currency:currencySymbol}}
                </div>
              }
            </div>
          }
          @if (price && price.exclusive && price.value !== -1) {
            <div class="exclusive">
              <img src="{{exclusiveImageUrl}}{{price.exclusive}}_small.png" alt="{{'exclusive'|translate}}">
            </div>
          }
          @if (price && price.clubPrice !== -1) {
            <div class="club-price" containerClass="club-price-tooltip"
              [tooltip]="clubPriceTemplate" triggers="click focus" #clubPriceToolTip="bs-tooltip">
              <span translate>Club Price <i class="fa fa-caret-left"></i></span>
            </div>
          }
          @if (showTotalSaved && price && price.striped !== -1) {
            <div class="total-saved">
              <span translate>Total Saved: </span>
              <span>{{price.striped - price.value |currency:price?.currency:currencySymbol}}</span>
            </div>
          }
          @if (price && price.value === -1) {
            <div translate>POA</div>
          }
        </div>
      } @else {
        @if (priceDisplay =='smallDigits') {
          <div class="d-flex">
            @if (price && price.value !== -1) {
              <div class="small-digits" [ngClass]="{'sale-price': price.striped !== -1}">
                <div>
                  <div [ngClass]="price && price.striped !== -1 && !price.hideStripedElements ? 'icon-striped' : 'hide-icon-striped'"></div>
                  <div class="price">
                    @if (price && price.striped !== -1) {
                      <div class="striped-price">
                        <!--<span>{{price?.fractionDigitsStripedInt|currency:price?.currency:currencySymbol:'0.0-0'}}<span class="fraction">{{price?.fractionDigitsStriped || '00'}}</span></span>-->
                        @if (!price.hideStripedElements) {
                          <label class="text-decoration-none striped-short-label" translate>Striped label</label>
                        }
                        <div class="striped">
                          <span class="price-currency">{{priceCurrency}}</span>
                          @if (!numberFormat) {
                            <span class="whole-number">{{price?.fractionDigitsStripedInt}}</span>
                          }
                          @if (numberFormat) {
                            <span class="whole-number">{{price?.fractionDigitsStripedInt|number}}</span>
                          }
                          <span class="hidden-point">{{(price?.fractionDigits || fractionDigits) ? '.' : ''}}</span>
                          <span class="fraction">{{price?.fractionDigitsStriped || fractionDigits}}</span>
                        </div>
                      </div>
                    }
                    @if (price && price.value !== -1) {
                      <div class="current-price" [ngClass]="{'sale-price': price.striped !== -1}">
                        <!--<span>{{price?.fractionDigitsInt|currency:price?.currency:currencySymbol:'0.0-0'}}<span class="fraction">{{price?.fractionDigits || '00'}}</span></span>-->
                        @if (priceCurrentLabel && price && price.striped !== -1 && !price.hideStripedElements) {
                          <label class="current-price-label" translate>Current price label</label>
                        }
                        <div class="price-cube">
                          <span class="price-currency">{{priceCurrency}}</span>
                          @if (!numberFormat) {
                            <span class="whole-number">{{(showAutoShipment && price.autoShipmentPrice !== -1 ? price.autoShipmentPrice : price?.fractionDigitsInt)}}</span>
                          }
                          @if (numberFormat) {
                            <span class="whole-number">{{(showAutoShipment && price.autoShipmentPrice !== -1 ? price.autoShipmentPrice : price?.fractionDigitsInt)|number}}</span>
                          }
                          <span class="hidden-point">{{(price?.fractionDigits || fractionDigits) ? '.' : ''}}</span>
                          <span class="fraction">{{price?.fractionDigits || fractionDigits}}</span>
                        </div>
                      </div>
                    }
                    @if (price && price.striped !== -1) {
                      <div class="d-none striped">
                        @if (!price.hideStripedElements) {
                          <label class="text-decoration-none striped-short-label" translate>Striped label</label>
                        }
                        <div>
                          <span>{{price?.fractionDigitsStripedInt|currency:price?.currency:currencySymbol:'0.0-0'}}</span>
                          <span class="hidden-point">{{(price?.fractionDigitsStriped) ? '.' : ''}}</span>
                          <span class="fraction">{{price?.fractionDigitsStriped || '00'}}</span>
                        </div>
                      </div>
                    }
                  </div>
                  @if (moreInfo) {
                    <div>
                      {{moreInfo}}
                    </div>
                  }
                </div>
                <!--<div *ngIf="price && price.exclusive && price.value !== -1" class="exclusive">-->
                <!--<img src="{{exclusiveImageUrl}}{{price.exclusive}}_small.png" alt="{{'exclusive'|translate}}">-->
              <!--</div>-->
              @if (price && price.clubPrice !== -1) {
                <div class="club-price" containerClass="club-price-tooltip"
                  [tooltip]="clubPriceTemplate" triggers="click focus" #clubPriceToolTip="bs-tooltip">
                  <span translate>Club Price <i class="fa fa-caret-left"></i></span>
                </div>
              }
              @if (showTotalSaved && price && price.striped !== -1) {
                <div class="total-saved">
                  <span translate>Total Saved: </span>
                  <span>{{price.fractionDigitsTotalSavedInt |currency:price?.currency:currencySymbol:'0.0-0'}}</span>
                  <span class="hidden-point">{{(price?.fractionDigitsTotalSaved) ? '.' : ''}}</span>
                  <span class="fraction">{{price.fractionDigitsTotalSaved || '00'}}</span>
                </div>
              }
            </div>
          }
          @if (price && price.clubPrice !== -1) {
            <div class="small-digits club d-none  pr-sm-5 pr-0" [ngClass]="{'sale-price': price.striped !== -1}">
              @if (price && price.clubPrice !== -1) {
                <div class="icon-club-price"></div>
              }
              <div class="inline-club-price" [ngClass]="{'sale-price': price.clubStripedPrice !== -1}">
                <!--{{price?.clubPrice|currency:price?.currency:currencySymbol}}-->
                <span>{{price?.fractionDigitsClubPriceInt|currency:price?.currency:currencySymbol:'0.0-0'}}</span>
                <span class="hidden-point">{{(price?.fractionDigitsClubPrice) ? '.' : ''}}</span>
                <span class="fraction">{{price?.fractionDigitsClubPrice || '00'}}</span>
              </div>
              @if (clubRegistrationLink) {
                <div class="register-to-club">
                  <a href="{{clubRegistrationLink}}" translate>Register to club</a>
                </div>
              }
            </div>
          }
          @if (price && price.value === -1) {
            <div translate>POA</div>
          }
        </div>
      }
      @if (priceDisplay =='eachPriceWhithStriped') {
        <div>
          <div class="each-price-whith-striped">
            @if (price && price.value !== -1) {
              <div class="current-price" [ngClass]="{'sale-price': price.striped !== -1}">
                <div>
                  <span class="priceLabel">{{'Your Price'|translate}}: </span>
                  {{price?.value|currency:price?.currency:currencySymbol}}
                  <span  class="postText" translate> each</span>
                </div>
                <div class="striped-wrap">
                  <span translate>List Price</span>
                  @if (price && price.striped !== -1) {
                    <span class="striped">
                      {{price?.striped|currency:price?.currency:currencySymbol}}
                    </span>
                  }
                </div>
              </div>
            }
            @if (price && price.exclusive && price.value !== -1) {
              <div class="exclusive">
                <img src="{{exclusiveImageUrl}}{{price.exclusive}}_small.png" alt="{{'exclusive'|translate}}">
              </div>
            }
            @if (price && price.clubPrice !== -1) {
              <div class="club-price" containerClass="club-price-tooltip"
                [tooltip]="clubPriceTemplate" triggers="click focus" #clubPriceToolTip="bs-tooltip">
                <span translate>Club Price <i class="fa fa-caret-left"></i></span>
              </div>
            }
            @if (showTotalSaved && price && price.striped !== -1) {
              <div class="total-saved">
                <span translate>Total Saved: </span>
                <span>{{price.striped - price.value |currency:price?.currency:currencySymbol}}</span>
              </div>
            }
            @if (price && price.value === -1) {
              <div  >
                <span class="priceLabel">{{'Your Price'|translate}}: </span>
                <span translate>POA</span>
              </div>
            }
          </div>
        </div>
      }
    }
    <div id="vatInfo" class="d-none">
      @if (proLoggedIn || b2bLoggedIn) {
        <div translate>
          Does not include VAT
        </div>
      } @else {
        <div translate>Including VAT</div>
      }
    </div>
  </div>
}
} @else {
  <contentloader [showTitle]="false"></contentloader>
}


<ng-template #clubPriceTemplate>
  @if (!priceDisplay) {
    <div class="club-tooltip ">
      <span class="close-tooltip" (click)="hideToolTip()"><i class="fa fa-times-circle"></i></span>
      <div class="tooltip-title" translate="">Price for club members</div>
      <div class="tooltip-price" [ngClass]="{'sale-price': price.clubStripedPrice !== -1}">
        {{price?.clubPrice|currency:price?.currency:currencySymbol}}
      </div>
      @if (price.clubStripedPrice !== -1) {
        <div class="striped">
          {{price?.clubStripedPrice|currency:price?.currency:currencySymbol}}
        </div>
      }
      @if (clubRegistrationLink) {
        <div class="register-to-club">
          <a href="{{clubRegistrationLink}}" translate>Register to club</a>
        </div>
      }
    </div>
  } @else {
    @if (priceDisplay =='smallDigits') {
      <div class="d-inline-block club-tooltip small-digits">
        <span class="close-tooltip" (click)="hideToolTip()"><i class="fa fa-times-circle"></i></span>
        <div class="tooltip-title" translate="">Price for club members</div>
        <div class="tooltip-price" [ngClass]="{'sale-price': price.clubStripedPrice !== -1}">
          <span>{{price?.fractionDigitsClubPriceInt|currency:price?.currency:currencySymbol:'0.0-0'}}</span>
          <span class="hidden-point">{{(price?.fractionDigitsClubPrice) ? '.' : ''}}</span>
          <span class="fraction">{{price?.fractionDigitsClubPrice || '00'}}</span>
        </div>
        @if (price.clubStripedPrice !== -1) {
          <div class="striped">
            <span>{{price?.fractionDigitsClubStripedPriceInt|currency:price?.currency:currencySymbol:'0.0-0'}}</span>
            <span class="hidden-point">{{(price?.fractionDigitsClubStripedPrice) ? '.' : ''}}</span>
            <span class="fraction">{{price?.fractionDigitsClubStripedPrice || '00'}}</span>
          </div>
        }
        @if (clubRegistrationLink) {
          <div class="register-to-club">
            <a href="{{clubRegistrationLink}}" translate>Register to club</a>
          </div>
        }
      </div>
    }
  }
</ng-template>



<!-- contentloader -->
<!-- /contentloader -->
